import { cn } from '@spiaggeit/spit-ui'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@/hooks/store'
import {
  INSERT_INSURANCE_PATH,
  INSERT_PERIOD_PATH,
  MAP_PATH,
  SECTOR_PATH,
  TICKETS_PATH,
} from '../app/router/paths'
import { useCurrentPath } from '../hooks/useCurrentPath'
import { appSlice } from '../store/appSlice'

export const Footer = () => {
  const isWebsite = useAppSelector(appSlice.selectors.isWebsiteMode)
  const { currentPath } = useCurrentPath()
  const { t } = useTranslation()

  /**
   * TODO: this logic could be moved within store
   * ui {
   *   footer: boolean
   * }
   **/
  if (
    !isWebsite ||
    [INSERT_PERIOD_PATH, MAP_PATH, SECTOR_PATH].includes(currentPath)
  ) {
    return null
  }

  return (
    <footer
      className={cn('text-primary-inverted bg-gray-900 py-8', {
        'hidden lg:block': [TICKETS_PATH, INSERT_INSURANCE_PATH].includes(
          currentPath
        ),
      })}
    >
      <div className="container">
        <p className="text-center text-xs">
          {t('footer.legalAddress')}
          <br />
          {t('footer.operationalAddress')}
          <br />
          {t('footer.copyright')}
        </p>
      </div>
    </footer>
  )
}
